"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const _ui_1 = require("@ui");
require("./style.scss");
const Checkbox = ({ onChange, disabled = false, checked = false, hasError = false, tabindex = 1, indeterminate = false, children = null, type = CHECKBOX_TYPES.DEFAULT, testid, onDisabledClick, }) => {
    const props = {
        size: _ui_1.Icon.SIZES.SMALL,
        color: hasError ? _ui_1.Icon.COLORS.RED : _ui_1.Icon.COLORS.PRIMARY,
    };
    const toggle = (e) => {
        if (disabled) {
            onDisabledClick?.();
            return;
        }
        !disabled &&
            onChange &&
            // @ts-expect-error
            (type === CHECKBOX_TYPES.INTERMINATE ? onChange(e, !checked) : onChange(!checked));
    };
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('checkbox', { disabled }), tabIndex: tabindex, role: 'checkbox', "aria-checked": indeterminate && !checked ? 'mixed' : checked, "aria-disabled": disabled, onClick: toggle, onKeyDown: (e) => {
            // what a native checkbox answers to. Anything focused inside the label — the
            // links a consent text carries — keeps its own Enter, hence the target check
            if (e.target !== e.currentTarget)
                return;
            if (e.key !== 'Enter' && e.key !== ' ')
                return;
            // Space would scroll the card instead of ticking the box
            e.preventDefault();
            toggle(e);
        } },
        react_1.default.createElement("div", { className: 'container' },
            indeterminate && !checked && react_1.default.createElement(_ui_1.Icon, { ico: 'checkbox-interminate', ...props }),
            checked && react_1.default.createElement(_ui_1.Icon, { testid: testid, ico: 'checkbox-checked', ...props }),
            !checked && !indeterminate && (react_1.default.createElement(_ui_1.Icon, { testid: testid, ico: 'checkbox-unchecked', ...props }))),
        children && react_1.default.createElement("div", { className: 'children' }, children)));
};
exports.Checkbox = Checkbox;
const CHECKBOX_TYPES = Object.freeze({
    DEFAULT: 'default',
    INTERMINATE: 'interminate',
});
exports.default = exports.Checkbox;
